import { render, staticRenderFns } from "./ProductTypeConfigurable.vue?vue&type=template&id=94265428"
import script from "./ProductTypeConfigurable.vue?vue&type=script&lang=ts"
export * from "./ProductTypeConfigurable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports